// 'clip', not 'hidden': the browser can still scroll an overflow:hidden box (e.g. when a focused
// input is brought into view), and nothing scrolls it back, so later steps render shifted (PLT-1002).
// Browsers without 'clip' (Safari < 16, Chrome < 90, Firefox < 81) would drop it and show every step,
// so they keep 'hidden'.
const supportsOverflowClip = typeof CSS !== 'undefined' && CSS.supports?.('overflow', 'clip') === true;
export const authWizardWrapperStyle = { overflow: supportsOverflowClip ? 'clip' : 'hidden' };

export enum SignUpWizardSteps {
  'SignUpPrivacy',
  'SignUpOptions',
  'SignUpEmailLanding',
  'ResponsibleSocialPlay',
  'SignUpRegister',
  'EmailVerification',
  'VerificationSuccess',
  'WelcomeBonusDialog',
  'ChooseCountry',
}

export enum SignUpWizardStepsRedesign {
  'SignUpOptions',
  'ResponsibleSocialPlay',
  'EmailVerification',
  'ChooseCountry',
}

// Step indexes of LogInWizard, which builds its step list from this enum
export enum LogInWizardStepsRedesign {
  'LogInOptions',
  'EmailVerification',
  'ChooseCountry',
  'WelcomeBonus',
}

// path = /?landing=direct_su
export const DirectSignUpLandingOrder = [
  SignUpWizardSteps.SignUpOptions,
  SignUpWizardSteps.ResponsibleSocialPlay,
  SignUpWizardSteps.SignUpRegister,
  SignUpWizardSteps.EmailVerification,
  SignUpWizardSteps.VerificationSuccess,
  SignUpWizardSteps.WelcomeBonusDialog,
  SignUpWizardSteps.ChooseCountry,
];
// path = /?landing=direct_em
export const DirectEmailLandingOrder = [
  SignUpWizardSteps.SignUpEmailLanding,
  SignUpWizardSteps.ResponsibleSocialPlay,
  SignUpWizardSteps.EmailVerification,
  SignUpWizardSteps.VerificationSuccess,
  SignUpWizardSteps.WelcomeBonusDialog,
  SignUpWizardSteps.ChooseCountry,
];

// path = /
export const SignupWizardOrder = [
  SignUpWizardSteps.SignUpPrivacy,
  SignUpWizardSteps.ResponsibleSocialPlay,
  SignUpWizardSteps.SignUpOptions,
  SignUpWizardSteps.SignUpRegister,
  SignUpWizardSteps.EmailVerification,
  SignUpWizardSteps.VerificationSuccess,
  SignUpWizardSteps.WelcomeBonusDialog,
  SignUpWizardSteps.ChooseCountry,
];

// sign up redesign
// path = /?landing=direct_su
// path = /?landing=direct_em
// path = /
export const SignupWizardOrderRedesignFlow = [
  SignUpWizardStepsRedesign.SignUpOptions,
  SignUpWizardStepsRedesign.EmailVerification,
  SignUpWizardStepsRedesign.ChooseCountry,
  SignUpWizardStepsRedesign.ResponsibleSocialPlay,
] as const;

export const PostSignupWizardOrderRedesignFlow = [
  SignUpWizardStepsRedesign.ChooseCountry,
  SignUpWizardStepsRedesign.ResponsibleSocialPlay,
] as const;
